import { useState } from "react";
import { Search } from "lucide-react";
import { AddressInput } from "@/components/fleet/AddressInput";
import { MapPreview } from "@/components/fleet/MapPreview";
import { t } from "@/lib/i18n";

const CHIPS = [
  { id: "airport", kind: "hub", label: "✈️ Aeroporti" },
  { id: "station", kind: "hub", label: "🚆 Stazioni" },
  { id: "Rientro a Vuoto", kind: "service", label: "↩️ Rientro a Vuoto" },
  { id: "Transfer Urbano", kind: "service", label: "🏙️ Transfer Urbano" },
];
const toBoard = () => document.getElementById("live-board")?.scrollIntoView({ behavior: "smooth", block: "start" });

export const HeroQuickChips = ({ hub, onHub, service, onService }) => (
  <div className="mt-3 flex gap-2 overflow-x-auto pb-1 max-w-2xl" data-testid="hero-quick-chips">
    {CHIPS.map((c) => {
      const active = c.kind === "hub" ? hub === c.id : service === c.id;
      const toggle = () => { (c.kind === "hub" ? onHub : onService)(active ? "" : c.id); toBoard(); };
      return (
        <button key={c.id} type="button" data-testid={`hero-chip-${c.id.toLowerCase().replace(/\s+/g, "-")}`} data-active={active} onClick={toggle} className="ff-chip whitespace-nowrap">
          {c.label.split(" ")[0]} {t(c.label.split(" ").slice(1).join(" "))}
        </button>
      );
    })}
  </div>
);

export const HeroSearch = ({ q, onQuery, onSearch }) => {
  const [point, setPoint] = useState(null);
  return (
    <div className="relative block" data-testid="hero-search-field">
      <Search size={20} strokeWidth={2.5} className="absolute left-4 top-8 -translate-y-1/2 text-[#3B82F6] pointer-events-none z-10" />
      <AddressInput testid="hero-search-input" gpsInline value={q} onChange={(v) => { onQuery(v); if (!v) setPoint(null); }} onPick={(p) => { setPoint(p); onQuery(/^[A-Z]{3} • /.test(p.label) ? p.label.slice(0, 3) : p.city || p.label.split(",")[0]); }}
        onEnter={onSearch} placeholder={t("CERCA TRATTA: Firenze, Milano, Aeroporto…")} inputClassName="h-16 text-base font-semibold border-[#3B82F6] !pl-12" />
      <MapPreview point={point} testid="hero-map" className="mt-3" />
    </div>
  );
};
